import { render, staticRenderFns } from "./lms_import_errors_modal.vue?vue&type=template&id=cf24b928&scoped=true&"
import script from "./lms_import_errors_modal.vue?vue&type=script&lang=js&"
export * from "./lms_import_errors_modal.vue?vue&type=script&lang=js&"
import style0 from "./lms_import_errors_modal.vue?vue&type=style&index=0&id=cf24b928&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf24b928",
  null
  
)

export default component.exports